/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Remove_Audio_From_Folder_DescInputs */

const en_dialog_remove_audio_from_folder_desc = /** @type {(inputs: Dialog_Remove_Audio_From_Folder_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The file will stay in your library and move back to Home.`)
};

const es_dialog_remove_audio_from_folder_desc = /** @type {(inputs: Dialog_Remove_Audio_From_Folder_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El archivo permanecerá en tu biblioteca y volverá al inicio.`)
};

/**
* | output |
* | --- |
* | "The file will stay in your library and move back to Home." |
*
* @param {Dialog_Remove_Audio_From_Folder_DescInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_remove_audio_from_folder_desc = /** @type {((inputs?: Dialog_Remove_Audio_From_Folder_DescInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Remove_Audio_From_Folder_DescInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_remove_audio_from_folder_desc(inputs)
	return en_dialog_remove_audio_from_folder_desc(inputs)
});